import React from 'react';

import isEmpty from 'lodash/isEmpty';

import TreeItem from './TreeItem';

const concatPath = (path, item, separator = '.') =>
  [path, item].filter(i => i || i === 0).join(separator);

const LAST_LEVEL_RENDER = 7;

export const TreeItemsDepth = ({ children, nodes }) => {
  const renderLevelDepth = (node, indexPath = '', entityIdsPath = '') => {
    const { id, entityId, depth, nodes } = node;

    if (depth > LAST_LEVEL_RENDER) {
      return null;
    }

    const toEntityIdsPath = concatPath(entityIdsPath, entityId, '/');

    return (
      <TreeItem
        key={id}
        to={toEntityIdsPath}
        node={node}
        element={children}
        lastItem={isEmpty(nodes) || depth >= LAST_LEVEL_RENDER}
        path={indexPath}
      >
        {nodes.map((node, index) => {
          const toIndexPath = concatPath(indexPath, `nodes[${index}]`);
          return renderLevelDepth(node, toIndexPath, toEntityIdsPath);
        })}
      </TreeItem>
    );
  };

  return nodes.map((node, index) => renderLevelDepth(node, `nodes[${index}]`));
};

export default TreeItemsDepth;
